import * as React from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';

import {Box, Typography,} from "@mui/material";
import {correctName, formatNumber, formatPercentage, getNomElection, getTrendIcon, tours} from "../Utils";


export default function SyntheseMain({results, stats, electionType}) {


    function getAnalyseEvolNuance() {
        let nuance20 = results[0].nuance.name
        let nuanceOld = nuance20;
        if (results.length > 1) {
            nuanceOld = results[1].nuance.name
        }
        if (nuance20 !== nuanceOld) {
            return (
                <Box sx={{width: "100%", display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>

                    <Typography variant={"body"} sx={{
                        color: "#f40a06",
                        fontWeight: 400,
                        fontStyle: "normal",

                        fontSize: {
                            md: "10px",
                            lg: "12px",
                            xl: "16px",
                        },
                        lineHeight: {
                            md: "10px",
                            lg: "12px",
                            xl: "16px",
                        }
                    }}>
                        Changement de nuance politique entre les deux dernieres elections
                    </Typography>
                </Box>
            )
        }
        return (<Box sx={{width: "100%", display: "flex", flexDirection: "row"}}>
        </Box>);
    }

    if (results) {

        return (

            <Box sx={{
                display: "flex", flexDirection: "row",
                paddingRight: "10px",
                alignItems: "center",
                gap: "20px",
                borderRadius: "10px",
                border: "1px solid #D5D5D5",
                background: "#FFF",
                width: "94%",
                pl: 5
            }}>
                <Box sx={{width: "100%", display: "flex", flexDirection: "column", gap: 1}}>
                    <Box sx={{height: 25, width: "100%", display: "flex", flexDirection: "row"}}>
                        <Box sx={{width: 150, display: "flex", flexDirection: "row", alignItems: 'center'}}>
                            <Typography variant={"body"} sx={{
                                color: "#000",
                                fontSize: "16px",
                                fontStyle: "normal",
                                fontWeight: 700,
                                lineHeight: "24px"
                            }}>
                                {getNomElection[electionType]}
                            </Typography>
                        </Box>
                        <Box sx={{width: 150, display: "flex", flexDirection: "row", alignItems: 'center'}}>
                            <Typography variant={"body"} sx={{
                                color: "#000",
                                fontSize: "16px",
                                fontStyle: "normal",
                                fontWeight: 700,
                                lineHeight: "24px"
                            }}>
                                Victoire
                            </Typography>
                        </Box>
                        <Box sx={{width: 300, display: "flex", flexDirection: "row", alignItems: 'center'}}>
                            <Typography variant={"body"} sx={{
                                color: "#000",
                                fontSize: "16px",
                                fontStyle: "normal",
                                fontWeight: 700,
                                lineHeight: "24px"
                            }}>
                                Gagnant
                            </Typography>
                        </Box>
                        <Box sx={{width: 300, display: "flex", flexDirection: "row", alignItems: 'center'}}>
                            <Typography variant={"body"} sx={{
                                color: "#000",
                                fontSize: "16px",
                                fontStyle: "normal",
                                fontWeight: 700,
                                lineHeight: "24px"
                            }}>
                                Nuance Politique
                            </Typography>
                        </Box>

                        <Box sx={{width: 150, display: "flex", flexDirection: "row", alignItems: 'center'}}>
                            <Typography variant={"body"} sx={{
                                color: "#000",
                                fontSize: "16px",
                                fontStyle: "normal",
                                fontWeight: 700,
                                lineHeight: "24px"
                            }}>
                                Abstention
                            </Typography>
                        </Box>

                    </Box>
                    {results.map((result, index) => {
                        return (
                            <Box key={index}
                                 sx={{height: 25, width: "100%", display: "flex", flexDirection: "row"}}>
                                <Box sx={{width: 150, display: "flex", flexDirection: "row", alignItems: 'center'}}>
                                    <Typography variant={"body"}
                                                sx={{
                                                    color: "#666",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight: 400,
                                                    lineHeight: "24px"
                                                }}>
                                        {result.year}
                                    </Typography>
                                </Box>

                                <Box sx={{width: 150, display: "flex", flexDirection: "row", alignItems: 'center'}}>
                                    <Typography variant={"body"}
                                                sx={{
                                                    color: "#666",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight: 400,
                                                    lineHeight: "24px"
                                                }}>
                                        {tours[result.tour]}
                                    </Typography>
                                </Box>
                                <Box sx={{width: 300, display: "flex", flexDirection: "row", alignItems: 'center'}}>
                                    <Box sx={{
                                        width: 8,
                                        height: 20,
                                        backgroundColor: result.winner.color,

                                        marginRight: 1
                                    }}/>
                                    <Typography variant={"body"} sx={{
                                        color: "#666",
                                        fontSize: "16px",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "24px",
                                        textOverflow: "ellipsis"
                                    }}>
                                        {correctName(result.winner.nomPrenom)}
                                        &nbsp;({formatPercentage(result.winner.perc)})
                                    </Typography>

                                </Box>

                                <Box sx={{width: 300, display: "flex", flexDirection: "row", alignItems: 'center'}}>
                                    <Box sx={{
                                        width: 20,
                                        height: 20,
                                        backgroundColor: result.nuance.color,
                                        borderRadius: 25,
                                        marginRight: 1
                                    }}/>
                                    <Typography variant={"body"}
                                                sx={{
                                                    color: "#666",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight: 400,
                                                    lineHeight: "24px",
                                                    textOverflow: "ellipsis"
                                                }}>
                                        {result.nuance.name}
                                    </Typography>
                                </Box>
                                <Box sx={{width: 150, display: "flex", flexDirection: "row", alignItems: 'stretch'}}>
                                    <Typography variant={"body"} sx={{
                                        color: "#666",
                                        fontSize: "16px",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "24px"
                                    }}>
                                        {getTrendIcon(result.abstention.trendPerc, true)}
                                    </Typography>
                                    <Typography variant={"body"} sx={{
                                        color: "#666",
                                        fontSize: "16px",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "24px"
                                    }}>
                                        {formatPercentage(result.abstention.perc)}
                                    </Typography>
                                </Box>

                            </Box>)
                    })}
                    <Box sx={{height: 25, width: "100%", display: "flex", flexDirection: "row"}}>
                        <Box sx={{width: "49%", display: "flex", flexDirection: "row", alignItems: 'center'}}>
                        </Box>
                        <Box sx={{
                            width: "49%",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: 'center'
                        }}>
                            {getAnalyseEvolNuance()}
                        </Box>
                    </Box>

                </Box>

            </Box>
        );
    }
}

